<template>
  <div class="print-button-bar col-12 mb-3">
    <div class="row d-none d-md-block print-button-container ml-1">
      <button class="col-sm-2 print-buttton px-2" @click="print">印刷する</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    print() {
      window.print();
    }
  }
}
</script>

<style scoped>
.print-button-container {
}

.print-button-bar {
  border-bottom: rgb(238, 238, 238) 3px solid;
  border-top: rgb(238, 238, 238) 3px solid;
}

.print-buttton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  display: flex;
  margin: 0;
  justify-content: center;
  align-items: center;
  height: 3rem;
  width: 100%;
}

.print-buttton:hover {
  opacity: 0.4;
  background-color: rgb(238, 238, 238);
}
</style>
